import { error } from "ajv/dist/vocabularies/applicator/dependencies.js";
import apiClient, { Image_Url } from "./ApiClient.js";

const getServerUrl = () => {
  if (typeof window !== "undefined" && window.location) {
    return window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"
      ? "http://localhost:3000"
      : "https://www.cradleai.net";
  }
  return "https://www.cradleai.net";
};
export const SERVER_URL = getServerUrl();
export const S3_URL = "https://cradleaibucket.s3.us-east-1.amazonaws.com";
export const IMAGE_BASE_URL =
  "https://cradleaibucket.s3.us-east-1.amazonaws.com";
export const ROOM_TYPE_FOLDER = "room-types/";
export { Image_Url };

// ============================================
// ADMIN PROFILE APIS
// ============================================

export const getAdminProfile = async (Id) => {
  console.log(Id);
  try {
    const response = await apiClient.post("private/get-admin-details", {
      id: Id,
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching admin profile:", error);
    throw error;
  }
};

export const updateAdminProfile = async (req) => {
  try {
    console.log(req);
    const res = await apiClient.put("private/updatedetails", req, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    console.log(error);
    return error.response?.data;
  }
};

export const getPrivacyPolicy = async () => {
  try {
    const response = await apiClient.get(`private/get-privacy-policy`);
    return response.data;
  } catch (error) {
    console.error("Error fetching privacy policy:", error);
    throw error;
  }
};

export const getReputationAudits = async (userId, status, page = 1) => {
  try {
    let url = `private/reputation-audits?page=${page}`;
    if (userId) url += `&userId=${userId}`;
    if (status) url += `&status=${status}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching reputation audits:", error);
    throw error;
  }
};

export const moderateReputationAudit = async (id, status, pointsOverride) => {
  try {
    const response = await apiClient.patch(`private/reputation-audits/${id}`, {
      status,
      pointsOverride,
    });
    return response.data;
  } catch (error) {
    console.error("Error moderating reputation audit:", error);
    throw error;
  }
};

export const savePrivacyPolicy = async (req) => {
  try {
    const res = await apiClient.post("/private/privacy-policy", req);
    return res.data;
  } catch (error) {
    console.log(error);
    return error.response?.data;
  }
};

export const getTermsAndConditions = async () => {
  try {
    const response = await apiClient.get(`private/get-terms-and-conditions`);
    return response.data;
  } catch (error) {
    console.error("Error fetching terms and conditions:", error);
    throw error;
  }
};

export const saveTermsAndConditions = async (payload) => {
  try {
    const response = await apiClient.post(
      `private/terms-and-conditions`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error saving terms and conditions:", error);
    throw error;
  }
};

// ============================================
// USERS APIS
// ============================================

export const getAllUsers = async (
  page = 1,
  limit = 10,
  search = "",
  statusFilter = "All",
  country = "All",
  state = "All",
  city = "All",
  reputationTier = "All",
) => {
  try {
    let url = `private/users?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`;
    if (statusFilter !== "All") {
      url += `&active=${statusFilter === "Active"}`;
    }
    if (country !== "All") {
      url += `&country=${encodeURIComponent(country)}`;
    }
    if (state !== "All") {
      url += `&state=${encodeURIComponent(state)}`;
    }
    if (city !== "All") {
      url += `&city=${encodeURIComponent(city)}`;
    }
    if (reputationTier !== "All") {
      url += `&reputationTier=${encodeURIComponent(reputationTier)}`;
    }
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getUserProfile = async (id) => {
  try {
    const response = await apiClient.get(`private/usersProfile/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const toggleUserStatus = async (id) => {
  try {
    const response = await apiClient.patch(`private/users/${id}/status`);
    return response.data;
  } catch (error) {
    console.error("Error toggling user status:", error);
    throw error;
  }
};

export const blockUserAPI = async (id, reason, action) => {
  console.log(id, reason, action);
  try {
    const response = await apiClient.patch(`private/users/block/${id}`, {
      reason,
      action,
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error blocking user:", error);
    throw error;
  }
};

export const resetUserPasswordAPI = async (payload) => {
  try {
    const response = await apiClient.post(`private/setNewPassword`, payload);
    return response.data;
  } catch (error) {
    console.error("Error resetting user password:", error);
    throw error;
  }
};

// ============================================
// COUNTRY & CITY APIS
// ============================================

export const getAllCountries = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
) => {
  try {
    const response = await apiClient.get("private/country", {
      params: { page, limit, search, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error;
  }
};

export const addCountry = async (data) => {
  try {
    const response = await apiClient.post("private/country", data);
    return response.data;
  } catch (error) {
    console.error("Error adding country:", error);
    throw error;
  }
};

export const updateCountry = async (id, data) => {
  try {
    const response = await apiClient.put(`private/country/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating country:", error);
    throw error;
  }
};

export const toggleCountryStatus = async (id) => {
  try {
    const response = await apiClient.patch(`private/country/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error toggling country status:", error);
    throw error;
  }
};

export const deleteCountry = async (id) => {
  try {
    const response = await apiClient.delete(`private/country/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting country:", error);
    throw error;
  }
};

export const getAllCities = async (
  page = 1,
  limit = 10,
  c_uuid = "",
  s_uuid = "",
  search = "",
  status = "",
) => {
  try {
    const response = await apiClient.get("private/get-city", {
      params: { page, limit, c_uuid, s_uuid, search, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching cities:", error);
    throw error;
  }
};

export const addCity = async (data) => {
  try {
    const response = await apiClient.post("private/add-city", data);
    return response.data;
  } catch (error) {
    console.error("Error adding city:", error);
    throw error;
  }
};

export const updateCity = async (id, data) => {
  try {
    const response = await apiClient.put(`private/update-city/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating city:", error);
    throw error;
  }
};

export const toggleCityStatus = async (id) => {
  try {
    const response = await apiClient.patch(`private/toggle-city-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error toggling city status:", error);
    throw error;
  }
};

export const deleteCity = async (id) => {
  try {
    const response = await apiClient.delete(`private/delete-city/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting city:", error);
    throw error;
  }
};

// State APIs
export const getAllStates = async (
  page = 1,
  limit = 10,
  c_uuid = "",
  search = "",
) => {
  try {
    const response = await apiClient.get("private/state", {
      params: { page, limit, c_uuid, search },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching states:", error);
    throw error;
  }
};

export const addState = async (data) => {
  try {
    const response = await apiClient.post("private/state", data);
    return response.data;
  } catch (error) {
    console.error("Error adding state:", error);
    throw error;
  }
};

export const updateState = async (id, data) => {
  try {
    const response = await apiClient.put(`private/state/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating state:", error);
    throw error;
  }
};

export const deleteState = async (id) => {
  try {
    const response = await apiClient.delete(`private/state/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting state:", error);
    throw error;
  }
};

export const getAllPermissions = async () => {
  try {
    const response = await apiClient.get("private/permissions");
    return response.data;
  } catch (error) {
    console.error("Error fetching permissions:", error);
    throw error;
  }
};

export const createRole = async (data) => {
  try {
    const response = await apiClient.post("private/roles", data);
    return response.data;
  } catch (error) {
    console.error("Error creating role:", error);
    throw error;
  }
};

export const getAllRoles = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await apiClient.get(
      `private/roles?page=${page}&limit=${limit}&search=${search}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching roles:", error);
    throw error;
  }
};

export const getRoleById = async (id) => {
  try {
    const response = await apiClient.get(`private/roles/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching role by id:", error);
    throw error;
  }
};

export const updateRole = async (id, data) => {
  try {
    const response = await apiClient.patch(`private/roles/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating role:", error);
    throw error;
  }
};

export const deleteRole = async (id) => {
  try {
    const response = await apiClient.delete(`private/roles/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting role:", error);
    throw error;
  }
};

export const getAllAdmins = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await apiClient.get(
      `private/role-management?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching admins:", error);
    throw error;
  }
};

export const deleteAdmin = async (id) => {
  try {
    const response = await apiClient.delete(`private/role-management/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting admin:", error);
    throw error;
  }
};

export const createAdmin = async (adminData) => {
  try {
    const response = await apiClient.post("private/role-management", adminData);
    return response.data;
  } catch (error) {
    console.error("Error creating admin:", error);
    throw error;
  }
};

export const updateAdmin = async (id, adminData) => {
  try {
    const response = await apiClient.patch(
      `private/role-management/${id}`,
      adminData,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating admin:", error);
    throw error;
  }
};

export const getAdminById = async (id) => {
  try {
    const response = await apiClient.get(`private/role-management/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching admin:", error);
    throw error;
  }
};

// ============================================
// REPUTATION TIERS APIS
// ============================================

export const getAllReputationTiers = async () => {
  try {
    const response = await apiClient.get("private/reputation-tier");
    return response.data;
  } catch (error) {
    console.error("Error fetching reputation tiers:", error);
    throw error;
  }
};

export const getReputationFlags = async (page = 1, limit = 10) => {
  try {
    const response = await apiClient.get(
      `private/get-reputation-flags?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching reputation flags:", error);
    throw error;
  }
};

export const getReputationUsers = async ({
  page = 1,
  limit = 10,
  search = "",
  tier = "",
  suspicious = "",
  minScore = "",
  maxScore = "",
  sort = "",
} = {}) => {
  try {
    const params = {
      page,
      limit,
    };

    if (search?.trim()) params.search = search.trim();
    if (tier) params.tier = tier;
    if (suspicious !== "") params.suspicious = suspicious;
    if (minScore !== "") params.minScore = minScore;
    if (maxScore !== "") params.maxScore = maxScore;

    // 🔥 SORT FIX
    if (sort) {
      const [field, order] = sort.split("_");
      params.sortField = field;
      params.sortOrder = order;
    }

    const response = await apiClient.get("private/reputation-users", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching reputation users:", error);
    throw error;
  }
};
export const addReputationTier = async (data) => {
  try {
    const response = await apiClient.post("private/reputation-tier", data);
    return response.data;
  } catch (error) {
    console.error("Error adding reputation tier:", error);
    throw error;
  }
};

export const updateReputationTier = async (id, data) => {
  try {
    const response = await apiClient.put(`private/reputation-tier/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating reputation tier:", error);
    throw error;
  }
};

export const deleteReputationTier = async (id) => {
  try {
    const response = await apiClient.delete(`private/reputation-tier/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting reputation tier:", error);
    throw error;
  }
};

export const toggleReputationTierStatus = async (id) => {
  try {
    const response = await apiClient.patch(`private/reputation-tier/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error toggling reputation tier status:", error);
    throw error;
  }
};

export const toggle2FA = async (email) => {
  try {
    const response = await apiClient.post("private/toggle-2fa", { email });
    return response.data;
  } catch (error) {
    console.error("Error toggling 2FA:", error);
    throw error;
  }
};
// ============================================
// AUDIT LOGS APIS
// ============================================

export const getAuditLogs = async (params = {}) => {
  try {
    const response = await apiClient.get("private/audit-logs", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching audit logs:", error);
    throw error;
  }
};

export const getAuditLogById = async (id) => {
  try {
    const response = await apiClient.get(`private/audit-logs/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching audit log by id:", error);
    throw error;
  }
};

export const getAuditLogFilters = async () => {
  try {
    const response = await apiClient.get("private/audit-log-filters");
    return response.data;
  } catch (error) {
    console.error("Error fetching audit log filters:", error);
    throw error;
  }
};
export const globalSearch = async (query) => {
  try {
    const response = await apiClient.get(
      `private/search?q=${encodeURIComponent(query)}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error performing global search:", error);
    throw error;
  }
};

export const getContact = async () => {
  try {
    const response = await apiClient.get("private/get-contact");
    return response.data;
  } catch (error) {
    console.error("Error fetching contact:", error);
    throw error;
  }
};

export const saveContact = async (data) => {
  try {
    const response = await apiClient.post("private/save-contact", data);
    return response.data;
  } catch (error) {
    console.error("Error saving contact:", error);
    throw error;
  }
};

export const getModerationQueue = async (
  page = 1,
  limit = 10,
  type = "",
  status = "",
  category = "",
) => {
  console.log("page", page);
  console.log("limit", limit);
  console.log("type", type);
  console.log("status", status);
  console.log("category", category);
  try {
    const params = { page, limit };
    if (type) params.type = type;
    if (status) params.status = status;
    if (category) params.category = category;
    const response = await apiClient.get(`private/moderation/queue`, {
      params,
    });
    console.log("response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching moderation queue:", error);
    throw error;
  }
};

export const updateModerationStatus = async (data) => {
  try {
    const response = await apiClient.post("private/moderation/status", data);
    return response.data;
  } catch (error) {
    console.error("Error updating moderation status:", error);
    throw error;
  }
};
export const getUserSessions = async (userId, page = 1, limit = 10) => {
  try {
    const response = await apiClient.get(`private/user-sessions/${userId}`, {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user sessions:", error);
    throw error;
  }
};

export const getAllSessions = async (page = 1, limit = 10) => {
  try {
    const response = await apiClient.get("private/all-sessions", {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all sessions:", error);
    throw error;
  }
};

export const getAdminSessions = async (page = 1, limit = 10) => {
  try {
    const response = await apiClient.get("private/sessions", {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin sessions:", error);
    throw error;
  }
};

// ─── Challenge & Submission Management ────────────────────────
export const getChallenges = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
) => {
  try {
    const response = await apiClient.get("private/challenges", {
      params: { page, limit, search, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching challenges:", error);
    throw error;
  }
};

export const createChallenge = async (data) => {
  try {
    // Accept raw FormData (from form submit) or a plain object
    const formData =
      data instanceof FormData
        ? data
        : (() => {
            const fd = new FormData();
            Object.keys(data).forEach((key) => {
              if (key === "image" && data[key] instanceof File) {
                fd.append(key, data[key]);
              } else if (data[key] !== undefined && data[key] !== null) {
                fd.append(key, data[key]);
              }
            });
            return fd;
          })();

    const response = await apiClient.post("private/challenges", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating challenge:", error);
    throw error;
  }
};

export const updateChallenge = async (id, data) => {
  try {
    const response = await apiClient.put(`private/challenges/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating challenge:", error);
    throw error;
  }
};

// ─── Report Type Management ───────────────────────────────────
export const getAllReportTypes = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
) => {
  try {
    const response = await apiClient.get("private/report-types", {
      params: { page, limit, search, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching report types:", error);
    throw error;
  }
};

export const addReportType = async (data) => {
  try {
    const response = await apiClient.post("private/report-types", data);
    return response.data;
  } catch (error) {
    console.error("Error adding report type:", error);
    throw error;
  }
};

export const updateReportType = async (id, data) => {
  try {
    const response = await apiClient.put(`private/report-types/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating report type:", error);
    throw error;
  }
};

export const toggleReportTypeStatus = async (id) => {
  try {
    const response = await apiClient.patch(`private/report-types/status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error toggling report type status:", error);
    throw error;
  }
};

export const deleteReportType = async (id) => {
  try {
    const response = await apiClient.delete(`private/report-types/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting report type:", error);
    throw error;
  }
};

export const getChallengeSubmissions = async (challengeId) => {
  try {
    const response = await apiClient.get(
      `private/challenges/${challengeId}/submissions`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching submissions:", error);
    throw error;
  }
};

export const judgeSubmission = async (id, status, feedback) => {
  try {
    const response = await apiClient.post(`private/submissions/${id}/judge`, {
      status,
      feedback,
    });
    return response.data;
  } catch (error) {
    console.error("Error judging submission:", error);
    throw error;
  }
};

export const rewardSubmission = async (id, rewardStatus) => {
  try {
    const response = await apiClient.post(`private/submissions/${id}/reward`, {
      rewardStatus,
    });
    return response.data;
  } catch (error) {
    console.error("Error rewarding submission:", error);
    throw error;
  }
};

export const terminateAdminSession = async (id) => {
  try {
    const response = await apiClient.delete(`private/sessions/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error terminating admin session:", error);
    throw error;
  }
};
export const logoutAdmin = async () => {
  try {
    const response = await apiClient.post("private/logout");
    return response.data;
  } catch (error) {
    console.error("Error during admin logout:", error);
    throw error;
  }
};
export const getSecurityConfig = async () => {
  try {
    const response = await apiClient.get("private/security-config");
    return response.data;
  } catch (error) {
    console.error("Error fetching security config:", error);
    throw error;
  }
};

export const updateSecurityConfig = async (configData) => {
  try {
    const response = await apiClient.post(
      "private/security-config",
      configData,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating security config:", error);
    throw error;
  }
};

export const createRoom = async (roomData) => {
  try {
    const response = await apiClient.post("private/create-room", roomData);
    return response.data;
  } catch (error) {
    console.error("Error creating room:", error);
    throw error;
  }
};

export const getAllRooms = async (params) => {
  try {
    const response = await apiClient.get("private/get-rooms", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching rooms:", error);
    throw error;
  }
};

export const getRoomDetail = async (id) => {
  try {
    const response = await apiClient.get(`private/get-room-detail/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching room detail:", error);
    throw error;
  }
};

export const getAllModerators = async () => {
  try {
    const response = await apiClient.get("private/get-all-moderators");
    return response.data;
  } catch (error) {
    console.error("Error fetching all moderators:", error);
    throw error;
  }
};

export const updateRoomMetadata = async (id, roomData) => {
  try {
    const response = await apiClient.patch(
      `private/update-room-metadata/${id}`,
      roomData,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating room metadata:", error);
    throw error;
  }
};

export const assignModerator = async (id, data) => {
  console.log("assignModerator", id, data);
  try {
    const response = await apiClient.post(
      `private/assign-moderator/${id}`,
      data,
    );
    console.log("assignModerator response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error assigning moderator:", error);
    throw error;
  }
};

export const removeModerator = async (id, data) => {
  console.log("removeModerator", id, data);
  try {
    const response = await apiClient.post(
      `private/remove-moderator/${id}`,
      data,
    );
    console.log("removeModerator response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error removing moderator:", error);
    throw error;
  }
};

export const archiveRoom = async (id, status) => {
  try {
    const response = await apiClient.patch(`private/archive-room/${id}`, {
      status,
    });
    return response.data;
  } catch (error) {
    console.error("Error archiving room:", error);
    throw error;
  }
};
// ============================================
// ACTION PERMISSIONS & REPUTATION ACTIONS
// ============================================

export const getAllActionPermissions = async () => {
  try {
    const response = await apiClient.get("private/action-permissions");
    return response.data;
  } catch (error) {
    console.error("Error fetching action permissions:", error);
    throw error;
  }
};

export const adjustReputationScore = async (data) => {
  try {
    const response = await apiClient.post("private/users/adjust-score", data);
    return response.data;
  } catch (error) {
    console.error("Error adjusting reputation score:", error);
    throw error;
  }
};

export const adjustReputation = async (id, data) => {
  try {
    const response = await apiClient.post(
      `private/users/${id}/adjust-reputation`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error adjusting reputation:", error);
    throw error;
  }
};

export const reverseReputationPenalty = async (
  id,
  reason,
  snapshotId = null,
) => {
  try {
    const response = await apiClient.post(
      `private/users/${id}/reverse-reputation`,
      { reason, snapshotId },
    );
    return response.data;
  } catch (error) {
    console.error("Error reversing reputation penalty:", error);
    throw error;
  }
};

export const getReputationHistory = async (
  id,
  hPage = 1,
  sPage = 1,
  limit = 5,
) => {
  try {
    const response = await apiClient.get(
      `private/users/${id}/reputation-history?hPage=${hPage}&sPage=${sPage}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching reputation history:", error);
    throw error;
  }
};

export const flagUserReputation = async (data) => {
  try {
    const response = await apiClient.post("private/users/flag", data);
    return response.data;
  } catch (error) {
    console.error("Error flagging user reputation:", error);
    throw error;
  }
};

export const unflagUserReputation = async (data) => {
  try {
    const response = await apiClient.post("private/users/unflag", data);
    return response.data;
  } catch (error) {
    console.error("Error unflagging user reputation:", error);
    throw error;
  }
};

export const applyReputationPenalty = async (id, data) => {
  try {
    const response = await apiClient.post(
      `private/users/${id}/adjust-reputation`,
      {
        ...data,
        scoreChange: data.points, // Map points to scoreChange as expected by backend
        penaltyStatus: "Applied",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error applying reputation penalty:", error);
    throw error;
  }
};

export const toggleUnderReview = async (id) => {
  try {
    // First get current state or just toggle via a dedicated PATCH if backend supports it
    // Based on index.js, we have updateUserSecurity at line 117
    // We'll use a generic security update call
    const response = await apiClient.patch(`private/users/${id}/security`, {
      isUnderReview: true, // The backend logic in updateUserSecurity handles this
    });
    return response.data;
  } catch (error) {
    console.error("Error toggling under review status:", error);
    throw error;
  }
};

// export const getReputationFlags = async (page = 1, limit = 10) => {
//   try {
//     const response = await apiClient.get(`private/get-reputation-flags?page=${page}&limit=${limit}`);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching reputation flags:", error);
//     throw error;
//   }
// };

// ============================================
// ROOM TYPES APIS
// ============================================

export const getAllRoomTypes = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
) => {
  try {
    const response = await apiClient.get("private/room-types", {
      params: { page, limit, search, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching room types:", error);
    throw error;
  }
};

export const addRoomType = async (formData) => {
  try {
    const response = await apiClient.post("private/room-types", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding room type:", error);
    throw error;
  }
};

export const updateRoomType = async (id, formData) => {
  try {
    const response = await apiClient.put(`private/room-types/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating room type:", error);
    throw error;
  }
};

export const deleteRoomType = async (id) => {
  try {
    const response = await apiClient.delete(`private/room-types/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting room type:", error);
    throw error;
  }
};

export const toggleRoomTypeStatus = async (id) => {
  try {
    const response = await apiClient.patch(`private/room-types/status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error toggling room type status:", error);
    throw error;
  }
};

export const getAiFlags = async (page = 1, limit = 10) => {
  try {
    const response = await apiClient.get(
      `/private/moderation/ai-flags?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching AI flags:", error);
  }
};

export const getEscalatedQueue = (page = 1, limit = 10, status = "") => {
  console.log("getEscalatedQueue =>", {
    page,
    limit,
    status,
  });

  return apiClient
    .get(
      `/private/moderation/escalated?page=${page}&limit=${limit}&status=${status}`,
    )
    .then((res) => {
      console.log("Escalated Queue Response =>", res.data);

      return res.data;
    })
    .catch((error) => {
      console.error("Escalated Queue Error =>", error);

      throw error;
    });
};

export const resolveEscalationAPI = (data) =>
  apiClient
    .post("/private/moderation/resolve-escalation", data)
    .then((res) => res.data);

export const getReputationStats = async () => {
  console.log("getReputationStats");
  try {
    const response = await apiClient.get("/private/reputation/stats");
    console.log("getReputationStats response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching reputation stats:", error);
    throw error;
  }
};

export const warnUser = async (data) => {
  try {
    const response = await apiClient.post(
      "/private/moderation/warn-user",
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error warning user:", error);
    throw error;
  }
};

export const getDashboardStats = async () => {
  try {
    const response = await apiClient.get("private/dashboard/stats");
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard stats:", error);
    throw error;
  }
};

export const getUserReports = async (page = 1, limit = 10, status = "") => {
  try {
    const params = { page, limit };
    if (status) params.status = status;
    const response = await apiClient.get(`/private/moderation/user-reports`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user reports:", error);
  }
};

export const getAllWalletTransactions = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  type = "",
  startDate = "",
  endDate = "",
  source = "",
) => {
  console.log(
    "getAllWalletTransactions",
    page,
    limit,
    search,
    status,
    type,
    startDate,
    endDate,
    source,
  );
  try {
    const response = await apiClient.get(
      `/private/get-wallet-transactions?page=${page}&limit=${limit}&search=${search}&status=${status}&type=${type}&startDate=${startDate}&endDate=${endDate}&source=${source}`,
    );
    console.log("getAllWalletTransactions response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching wallet transactions:", error);
    throw error;
  }
};

export const getAllKycSubmissions = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  startDate = "",
  endDate = "",
) => {
  try {
    const response = await apiClient.get(
      `/private/get-all-kyc-submissions?page=${page}&limit=${limit}&search=${search}&status=${status}&startDate=${startDate}&endDate=${endDate}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching kyc requests:", error);
    throw error;
  }
};

export const approveKyc = async (id) => {
  try {
    const response = await apiClient.post(
      `/private/prove-kyc-submission/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error approving kyc:", error);
    throw error;
  }
};

export const rejectKyc = async (id, data) => {
  try {
    const response = await apiClient.post(
      `/private/reject-kyc-submission/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error rejecting kyc:", error);
    throw error;
  }
};

export const requestMoreInfoKyc = async (id, reason) => {
  try {
    const response = await apiClient.post(`/private/send-kyc-email/${id}`, {
      reason,
    });
    return response.data;
  } catch (error) {
    console.error("Error requesting more kyc info:", error);
    throw error;
  }
};

export const resetUserPin = async (id, data) => {
  try {
    const response = await apiClient.post(`/private/reset-pin/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error resetting user pin:", error);
    throw error;
  }
};

export const flagWalletTransaction = async (id, reason) => {
  try {
    const response = await apiClient.patch(
      `private/wallet-transaction/${id}/flag`,
      { reason },
    );
    return response.data;
  } catch (error) {
    console.error("Error flagging wallet transaction:", error);
    throw error;
  }
};

export const reverseWalletTransaction = async (id, reason) => {
  try {
    const response = await apiClient.patch(
      `private/wallet-transaction/${id}/reverse`,
      { reason },
    );
    return response.data;
  } catch (error) {
    console.error("Error reversing wallet transaction:", error);
    throw error;
  }
};

// ============================================
// CREATOR APIS
// ============================================

export const getCreatorTypeCodes = async () => {
  try {
    const response = await apiClient.get("private/get-creator-type-codes");
    return response.data;
  } catch (error) {
    console.error("Error fetching creator type codes:", error);
    throw error;
  }
};

export const createCreator = async (data) => {
  try {
    const response = await apiClient.post("private/create-creator", data);
    return response.data;
  } catch (error) {
    console.error("Error creating creator:", error);
    throw error;
  }
};

export const getAllCreators = async (page = 1, limit = 10) => {
  try {
    const response = await apiClient.get(
      `private/get-creators?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching creator categories:", error);
    throw error;
  }
};

export const getCreatorById = async (id) => {
  try {
    const response = await apiClient.get(`private/get-creator/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator category:", error);
    throw error;
  }
};

export const updateCreator = async (id, data) => {
  try {
    const response = await apiClient.put(`private/update-creator/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating creator category:", error);
    throw error;
  }
};

export const toggleCreatorStatus = async (id) => {
  try {
    const response = await apiClient.patch(
      `private/toggle-creator-status/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error toggling creator status:", error);
    throw error;
  }
};

export const deleteCreator = async (id) => {
  try {
    const response = await apiClient.delete(`private/delete-creator/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting creator category:", error);
    throw error;
  }
};

// ============================================
// PROMOTION PLAN APIS
// ============================================

export const createPromotionPlan = async (data) => {
  try {
    const response = await apiClient.post(
      "private/create-promotion-plan",
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating promotion plan:", error);
    throw error;
  }
};

export const getAllPromotionPlans = async (
  page = 1,
  limit = 10,
  search = "",
) => {
  try {
    const response = await apiClient.get("private/get-promotion-plans", {
      params: { page, limit, search },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching promotion plans:", error);
    throw error;
  }
};

export const getPromotionPlanById = async (id) => {
  try {
    const response = await apiClient.get(`private/get-promotion-plan/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching promotion plan:", error);
    throw error;
  }
};

export const updatePromotionPlan = async (id, data) => {
  try {
    const response = await apiClient.put(
      `private/update-promotion-plan/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating promotion plan:", error);
    throw error;
  }
};

export const deletePromotionPlan = async (id) => {
  try {
    const response = await apiClient.delete(
      `private/delete-promotion-plan/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting promotion plan:", error);
    throw error;
  }
};

export const creatorRequestStatus = async (id, data) => {
  try {
    const response = await apiClient.patch(
      `private/creator-request-status/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating creator request status:", error);
    throw error;
  }
};

// Create Referral Config
export const createReferralConfig = async (data) => {
  try {
    const response = await apiClient.post(`private/referral-config`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getReferralConfig = async () => {
  try {
    const response = await apiClient.get(`private/referral-config`);
    return response.data;
  } catch (error) {
    console.error("Error fetching referral config:", error);
    throw error;
  }
};

export const updateReferralConfig = async (data) => {
  try {
    const response = await apiClient.put(
      `private/update/referral-config`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating referral config:", error);
    throw error;
  }
};

export const getAllJudges = async () => {
  try {
    const response = await apiClient.get("/private/getAllJudges");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateChallengeStatus = async (c_uuid, c_status) => {
  try {
    const response = await apiClient.patch(`private/challenges/${c_uuid}`, {
      c_status,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating challenge status:", error);
    throw error;
  }
};

// ─── Challenge Join Requests ──────────────────────────────────────
export const getChallengeJoinRequests = async (
  page = 1,
  limit = 10,
  status = "",
  search = "",
) => {
  try {
    const params = { page, limit };
    if (status) params.status = status;
    if (search) params.search = search;
    const response = await apiClient.get("private/challenge-join-requests", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching challenge join requests:", error);
    throw error;
  }
};

export const updateJoinRequestStatus = async (id, status) => {
  try {
    const response = await apiClient.patch(
      `private/challenge-join-requests/${id}`,
      { status },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating join request status:", error);
    throw error;
  }
};

export const getAllSubmissions = async (page = 1, limit = 10, search = "") => {
  console.log("page", page);
  console.log("limit", limit);
  console.log("search", search);
  try {
    const params = { page, limit };
    if (search) params.search = search;
    const response = await apiClient.get("private/get-all-submissions", {
      params,
    });
    console.log("response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching submissions:", error);
    throw error;
  }
};

export const createResult = async (data) => {
  try {
    const response = await apiClient.post("private/createResult", data);
    return response.data;
  } catch (error) {
    console.error("Error creating result:", error);
    throw error;
  }
};

export const getCategories = async () => {
  try {
    const response = await apiClient.get("private/get-categories");
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const getSubmissions = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
) => {
  try {
    const params = { page, limit };
    if (search) params.search = search;
    if (status) params.status = status;
    const response = await apiClient.get("private/get-submissions", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching submissions:", error);
    throw error;
  }
};

export const submitJudgeScores = async (payload) => {
  try {
    const response = await apiClient.post("private/submit-score", payload);
    return response.data;
  } catch (error) {
    console.error("Error submitting judge scores:", error);
    throw error;
  }
};

export const getSubmissionListById = async (id, page = 1, limit = 10) => {
  console.log("id", id);
  console.log("page", page);
  console.log("limit", limit);
  try {
    const response = await apiClient.get(`/private/get-submissions/${id}`, {
      params: { page, limit },
    });
    console.log("response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching submissions by id:", error);
    throw error;
  }
};

export const getJudgeChallenge = async () => {
  try {
    const response = await apiClient.get("private/judge/my-challenge");
    return response.data;
  } catch (error) {
    console.error("Error fetching judge challenge:", error);
    throw error;
  }
};

export const getReputationConfig = async () => {
  try {
    const response = await apiClient.get("private/reputation-config");
    return response.data;
  } catch (error) {
    console.error("Error fetching reputation config:", error);
    throw error;
  }
};

export const getChangeRequests = async (page = 1, limit = 10) => {
  try {
    const response = await apiClient.get("private/getChangeRequests", {
      params: { page, limit },
    });
    console.log(response, "hohu8hgushuoichgcgs08cg8");
    return response.data;
  } catch (error) {
    console.log("Error fetching Change Requests", error);
    throw error;
  }
};

export const updateReputationConfig = async (data) => {
  try {
    const response = await apiClient.post("private/reputation-config", data);
    return response.data;
  } catch (error) {
    console.error("Error updating reputation config:", error);
    throw error;
  }
};

export const handleRequest = async (_id, status) => {
  try {
    const response = await apiClient.post("private/handleRequest", {
      _id,
      status,
    });

    return response.data;
  } catch (error) {
    console.log("Error handling request", error);
    throw error;
  }
};

export const getInnovationBoards = async ({
  page = 1,
  limit = 10,
  search = "",
  status = "",
} = {}) => {
  try {
    const response = await apiClient.get("private/getinnovationboards", {
      params: {
        page,
        limit,
        search,
        status,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching innovation boards:", error);
    throw error;
  }
};

export const getReferralEvents = async ({
  page = 1,
  limit = 10,
  search = "",
  status = "",
  fraud = "",
} = {}) => {
  try {
    const response = await apiClient.get("private/referrals", {
      params: {
        page,
        limit,
        search,
        status,
        fraud,
      },
    });

    return response.data;
  } catch (error) {
    console.error(" API ERROR:", error);
    throw error;
  }
};

export const getCreatorChannels = async ({
  page = 1,
  limit = 10,
  search = "",
  status = "",
  contentType = "",
} = {}) => {
  try {
    const response = await apiClient.get("private/getCreatorChannels", {
      params: {
        page,
        limit,
        search,
        status,
        contentType,
      },
    });
    console.log("Channels API Response:", response);
    return response.data;
  } catch (error) {
    console.error("API ERROR:", error);
    throw error;
  }
};

export const getdashboardstate = async () => {
  try {
    const response = await apiClient.get("private/getdashboardstate");
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard state:", error);
    throw error;
  }
};

// ============================================
// CREATOR REQUEST APIS
// ============================================

export const getAllCreatorRequests = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
) => {
  try {
    const response = await apiClient.get(`private/get-creator-requests`, {
      params: { page, limit, search, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching creator requests:", error);
    throw error;
  }
};

export const updateCreatorRequestStatus = async (id, data) => {
  try {
    const response = await apiClient.patch(
      `private/creator-request-status/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating creator request status:", error);
    throw error;
  }
};

// ============================================
// DISPUTE MANAGEMENT APIS
// ============================================

export const getAllDisputes = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
) => {
  try {
    let url = `private/disputes?page=${page}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (status && status !== "All") url += `&status=${status.toLowerCase()}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching disputes:", error);
    throw error;
  }
};

export const updateDisputeStatus = async (id, data) => {
  try {
    const response = await apiClient.patch(
      `private/disputes/${id}/status`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating dispute status:", error);
    throw error;
  }
};

export const sendDisputePolicyEmail = async (id) => {
  try {
    const response = await apiClient.post(
      `private/disputes/${id}/send-policy-email`,
    );
    return response.data;
  } catch (error) {
    console.error("Error sending dispute policy email:", error);
    throw error;
  }
};

// Analytics & Growth Monitoring endpoints
export const getChatRoomMetrics = async () => {
  try {
    const response = await apiClient.get("private/analytics/chat-room-metrics");
    return response.data;
  } catch (error) {
    console.error("Error fetching chat room metrics:", error);
    throw error;
  }
};

export const getReferralStats = async () => {
  try {
    const response = await apiClient.get("private/analytics/referral-stats");
    return response.data;
  } catch (error) {
    console.error("Error fetching referral stats:", error);
    throw error;
  }
};

export const getHackathonOverview = async () => {
  try {
    const response = await apiClient.get("private/analytics/hackathon");
    return response.data;
  } catch (error) {
    console.error("Error fetching hackathon overview:", error);
    throw error;
  }
};

export const getInnovationBoardStats = async () => {
  try {
    const response = await apiClient.get("private/analytics/innovation-board");
    return response.data;
  } catch (error) {
    console.error("Error fetching innovation board stats:", error);
    throw error;
  }
};

export const getCommunityFeatureStats = async () => {
  try {
    const response = await apiClient.get(
      "private/analytics/community-features",
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching community feature stats:", error);
    throw error;
  }
};

export const getUserMemberships = async (
  pageOrParams = 1,
  limit = 10,
  search = "",
  status = "",
  tier = "",
) => {
  try {
    let params = { page: 1, limit: 10, search: "", status: "", tier: "" };
    if (typeof pageOrParams === "object" && pageOrParams !== null) {
      params = { ...params, ...pageOrParams };
    } else {
      params.page = pageOrParams;
      params.limit = limit;
      params.search = search;
      params.status = status;
      params.tier = tier;
    }
    const response = await apiClient.get(`private/getUserMemberships`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user memberships:", error);
    throw error;
  }
};

export const getKycHistory = async (id, page = 1, limit = 10) => {
  const response = await apiClient.get("private/getKycDetails", {
    params: {
      id,
      page,
      limit,
    },
  });

  return response.data;
};
// ============================================
// 🎁 GIFT CONFIG APIS (Admin)
// ============================================

export const getGiftConfig = async () => {
  try {
    const response = await apiClient.get("private/gift-config");
    return response.data;
  } catch (error) {
    console.error("Error fetching gift config:", error);
    throw error;
  }
};

export const updateGiftConfig = async (data) => {
  try {
    const response = await apiClient.put("private/gift-config", data);
    return response.data;
  } catch (error) {
    console.error("Error updating gift config:", error);
    throw error;
  }
};

export const toggleGiftConfigStatus = async () => {
  try {
    const response = await apiClient.patch("private/gift-config/toggle");
    return response.data;
  } catch (error) {
    console.error("Error toggling gift config status:", error);
    throw error;
  }
};

export const getChallengeResults = async (challengeId) => {
  try {
    const response = await apiClient.get(
      `/private/get-submissions/${challengeId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching challenge results:", error);
    throw error;
  }
};

// ============================================
// PACKAGES APIS
// ============================================

export const getAllPackagesAPI = async () => {
  try {
    const response = await apiClient.get("/private/packages");
    return response.data;
  } catch (error) {
    console.error("Error fetching packages:", error);
    throw error;
  }
};

export const createPackageAPI = async (data) => {
  try {
    const response = await apiClient.post("/private/packages", data);
    return response.data;
  } catch (error) {
    console.error("Error creating package:", error);
    throw error;
  }
};

export const updatePackageAPI = async (id, data) => {
  try {
    const response = await apiClient.put(`/private/packages/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating package:", error);
    throw error;
  }
};

export const deletePackageAPI = async (id) => {
  try {
    const response = await apiClient.delete(`/private/packages/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting package:", error);
    throw error;
  }
};

// ============================================
// WITHDRAWAL FUND MANAGEMENT APIS
// ============================================

export const getAllWithdrawals = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  startDate = "",
  endDate = "",
) => {
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (limit) params.append("limit", limit);
    if (search) params.append("search", search);
    if (status && status !== "All") params.append("status", status);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const response = await apiClient.get(`/private/withdrawals?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching withdrawals:", error);
    throw error;
  }
};

export const getWithdrawalById = async (id) => {
  try {
    const response = await apiClient.get(`/private/withdrawals/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching withdrawal details:", error);
    throw error;
  }
};

export const updateWithdrawalStatus = async (id, status, notes = "") => {
  try {
    const response = await apiClient.patch(`/private/withdrawals/${id}/status`, {
      status,
      notes,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating withdrawal status:", error);
    throw error;
  }
};

export const getWithdrawalStats = async () => {
  try {
    const response = await apiClient.get(`/private/withdrawals/stats`);
    return response.data;
  } catch (error) {
    console.error("Error fetching withdrawal stats:", error);
    throw error;
  }
};


